import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './modules/auth/authSlice';
import branchReducer from './modules/branch/slice';
import patientRegistrationReducer from './modules/admin/patientRegistartion/slice'
import patientInformationReducer from './modules/admin/patientInformation/slice'
import patientEmergencyContactReducer from './modules/admin/patientEmergencyContactInfo/slice'
import patientInsuranceReducer from './modules/admin/patientInsurance/slice'
import patientPhysicianReducer from './modules/admin/patientPhysician/slice'
import patientMedicalHistoryReducer from './modules/admin/patientMedicalHistory/slice'
import patientLifeStyleReducer from './modules/admin/patientLifeStyle/slice'
import patientAcknowledgementReducer from './modules/admin/patientAcknowledgement/slice'
import patientProfileReducer from './modules/admin/patientProfile/slice'
import profileReducer from './modules/profile/slice';
import radiologyReducer from './modules/radiology/slice';
import staffReducer from './modules/staff/slice';
import examReducer from './modules/exam/slice';
import mainHeadingReducer from './modules/mainHeading/slice';
import verifySignatureReducer from './modules/verifySignature/slice';
import appointmentReducer from './modules/appoinment/slice';
import setShowListReducer from './modules/showList/slice';
import ordersReducer from './modules/orders/slice';
import reportReducer from './modules/report/slice';
import dashboardReducer from "./modules/dashboard/slice";
import invoiceReducer from "./modules/invoice/slice"
import voucherReducer from "./modules/voucher/slice"
import analyticsReducer from "./modules/analytics/slice"
import referralReducer from "./modules/referral/slice"
import modalitiesReducer from './modules/modality/slice'
import enquiryReducer from "./modules/home/slice";
import notificationReducer from './modules/notification/slice';
import patientsReducer from './modules/patients/slice';
import externalReferrerReducer from './modules/externalReferrer/slice';
import allStudiesReducer from './modules/allStudies/slice';
import reportTemplateReducer from './modules/reportTemplate/slice';
import labDepartmentReducer from './modules/laboratory/labDepartment/slice';
import labSpecimenTypeReducer from './modules/laboratory/labSpecimenType/slice';
import labTestReducer from './modules/laboratory/labTest/slice';
import labTestPanelReducer from './modules/laboratory/labTestPanel/slice';
import labOrderReducer from './modules/laboratory/labOrder/slice';
import labSpecimenReducer from './modules/laboratory/labSpecimen/slice';
import labResultReducer from './modules/laboratory/labResult/slice';
import labAnalyzerReducer from './modules/laboratory/labAnalyzer/slice';
import labQCReducer from './modules/laboratory/labQC/slice';
import labEquipmentReducer from './modules/laboratory/labEquipment/slice';
import labReagentReducer from './modules/laboratory/labReagent/slice';
import labReportReducer from './modules/laboratory/labReport/slice';
import labAnalyticsReducer from './modules/laboratory/labAnalytics/slice';
import labAlertReducer from './modules/laboratory/labAlert/slice';
import labUnmatchedResultReducer from './modules/laboratory/labUnmatchedResult/slice';
import permissionsReducer from './modules/permissions/slice';
import auditLogReducer from './modules/auditLog/slice';
import hospitalConfigReducer from './modules/hospitalConfig/slice';


const rootReducer = combineReducers({
  auth: authReducer,
  branch: branchReducer,
  patientRegistration: patientRegistrationReducer,
  patientInformation: patientInformationReducer,
  patientEmergencyContact: patientEmergencyContactReducer,
  patientInsurance: patientInsuranceReducer,
  patientPhysician: patientPhysicianReducer,
  patientMedicalHistory: patientMedicalHistoryReducer,
  patientLifeStyle: patientLifeStyleReducer,
  patientAcknowledgement: patientAcknowledgementReducer,
  patientProfile: patientProfileReducer,
  profile: profileReducer,
  radiology: radiologyReducer,
  staff: staffReducer,
  exam: examReducer,
  mainHeading: mainHeadingReducer,
  verifySignature: verifySignatureReducer,
  appointment: appointmentReducer,
  reduxShowList: setShowListReducer,
  orders: ordersReducer,
  report: reportReducer,
  dashboard: dashboardReducer,
  invoice: invoiceReducer,
  voucher: voucherReducer,
  analytics: analyticsReducer,
  referral: referralReducer,
  modalities: modalitiesReducer,
  enquiry: enquiryReducer,
  notification: notificationReducer,
  patients: patientsReducer,
  externalReferrer: externalReferrerReducer,
  allStudies: allStudiesReducer,
  reportTemplate: reportTemplateReducer,
  labDepartment: labDepartmentReducer,
  labSpecimenType: labSpecimenTypeReducer,
  labTest: labTestReducer,
  labTestPanel: labTestPanelReducer,
  labOrder: labOrderReducer,
  labSpecimen: labSpecimenReducer,
  labResult: labResultReducer,
  labAnalyzer: labAnalyzerReducer,
  labQC: labQCReducer,
  labEquipment: labEquipmentReducer,
  labReagent: labReagentReducer,
  labReport: labReportReducer,
  labAnalytics: labAnalyticsReducer,
  labAlert: labAlertReducer,
  labUnmatchedResult: labUnmatchedResultReducer,
  permissions: permissionsReducer,
  auditLog: auditLogReducer,
  hospitalConfig: hospitalConfigReducer,
});

export default rootReducer;